export default __webpack_public_path__ + "static/media/nodata.37269d96.svg";